import './assets/sass/style.scss';
import { StoreProvider, useStoreRehydrated } from 'easy-peasy';
import React from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './modules/app/App';
import { store } from './store';
import { applyThemeColors } from './utils/iframe/applyThemeColors';
import { parseUrlContext } from './utils/iframe/parseUrlContext';

interface WaitForStateRehydrationProps {
  children: React.ReactNode;
}

const WaitForStateRehydration: React.FC<WaitForStateRehydrationProps> = ({ children }) => {
  const isRehydrated = useStoreRehydrated();
  return isRehydrated ? (children as React.ReactElement) : null;
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

// Theme colors only — orgContext URL params are applied after store rehydration
// in UrlContextSync (bootstrap setContext is wiped when navigation persist rehydrates).
const bootstrapThemeFromUrl = () => {
  const partial = parseUrlContext(window.location.search);
  applyThemeColors(partial.primaryColor, partial.textColorOverride);
};

bootstrapThemeFromUrl();

root.render(
  <StoreProvider store={store}>
    <WaitForStateRehydration>
      <App />
    </WaitForStateRehydration>
  </StoreProvider>
);
